
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"800","height":"800","viewBox":"0 0 800 800","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M584.443 776.578H231.615c-50.608 0-91.781-41.174-91.781-91.783V254.301c0-11.046 8.954-20 20-20s20 8.954 20 20v430.494c0 28.554 23.229 51.783 51.781 51.783h352.829c19.697 0 35.723-16.024 35.723-35.723V266.312c0-19.697-16.023-35.722-35.721-35.722H243.418c-57.117 0-103.585-46.468-103.585-103.584S186.301 23.422 243.418 23.422l332.593.013c11.047.001 20 8.955 20 20.001 0 11.045-8.955 19.999-20 19.999l-332.594-.013c-35.06 0-63.584 28.523-63.584 63.584s28.524 63.584 63.585 63.584h341.027c41.754 0 75.721 33.969 75.721 75.722v434.544c0 41.753-33.969 75.722-75.723 75.722zM640.166 63.438h-3.322c-11.045 0-20-8.954-20-20s8.955-20 20-20h3.322c11.047 0 20 8.954 20 20s-8.953 20-20 20z"}}),_c('path',{attrs:{"d":"M556.063 679.967H243.935c-11.046 0-20-8.954-20-20v-352.77c0-11.046 8.954-20 20-20h312.127c11.047 0 20 8.954 20 20s-8.953 20-20 20H263.935v312.77h272.127V376.5c0-11.046 8.955-20 20-20 11.047 0 20 8.954 20 20v283.467c.001 11.046-8.953 20-19.999 20z"}}),_c('path',{attrs:{"d":"M472.689 413.792h-145.38c-11.046 0-20-8.954-20-20s8.954-20 20-20h145.38c11.047 0 20 8.954 20 20s-8.953 20-20 20zM472.689 503.583h-145.38c-11.046 0-20-8.954-20-20s8.954-20 20-20h145.38c11.047 0 20 8.954 20 20s-8.953 20-20 20zM472.689 593.372h-145.38c-11.046 0-20-8.954-20-20s8.954-20 20-20h145.38c11.047 0 20 8.954 20 20s-8.953 20-20 20zM556.791 147.006H308.09c-11.046 0-20-8.954-20-20s8.954-20 20-20h248.701c11.047 0 20 8.954 20 20s-8.953 20-20 20zM247.257 147.006h-3.322c-11.046 0-20-8.954-20-20s8.954-20 20-20h3.322c11.046 0 20 8.954 20 20s-8.954 20-20 20z"}})])
          )
        }
      }
    